// v6 — multi-tier support, square Claim button / checkmark badge
(function () {

  class FreeGiftBar {
    constructor(el) {
      this.el = el;
      this.minCents = parseInt(el.dataset.minCents, 10);
      this.variantId = String(el.dataset.variantId);
      this.label = el.dataset.label;
      this.fillEl = el.querySelector('[data-fgb-fill]');
      this.remainingEls = el.querySelectorAll('[data-fgb-remaining]');
      this.btn = el.querySelector('[data-fgb-btn]');

      var self = this;
      this.btn && this.btn.addEventListener('click', function () { self.addGift(); });

      this.fetchAndUpdate();
      this.listenForCartUpdates();
    }

    update(totalCents, items) {
      items = items || [];
      var progress = Math.min(100, Math.round((totalCents / this.minCents) * 100));
      var remainingCents = Math.max(0, this.minCents - totalCents);
      var thresholdMet = totalCents >= this.minCents;
      var variantId = this.variantId;
      var giftInCart = items.some(function (item) { return String(item.variant_id) === variantId; });
      var claimed = giftInCart && thresholdMet;
      var belowThreshold = giftInCart && !thresholdMet;

      if (this.fillEl) this.fillEl.style.width = progress + '%';
      var fmt = this.formatMoney(remainingCents);
      this.remainingEls.forEach(function (el) { el.textContent = fmt; });

      this.el.classList.toggle('free-gift-bar--claimed', claimed);
      this.el.classList.toggle('free-gift-bar--below-threshold', belowThreshold);
      this.el.classList.toggle('free-gift-bar--unlocked', thresholdMet && !giftInCart);

      if (giftInCart) this.disableGiftPlusButton();
    }

    disableGiftPlusButton() {
      var vid = this.variantId;
      document.querySelectorAll('cart-drawer-qty-button[variant-id="' + vid + '"]').forEach(function (btn) {
        if (Array.from(btn.classList).some(function (c) { return c.indexOf('plus') !== -1; })) {
          btn.setAttribute('disabled', '');
          btn.classList.add('@disabled');
        }
      });
    }

    formatMoney(cents) {
      return 'RM ' + (cents / 100).toFixed(2);
    }

    addGift() {
      if (!this.variantId || (this.btn && this.btn.disabled)) return;
      if (this.btn) { this.btn.disabled = true; this.btn.textContent = '...'; }

      var self = this;
      var isCartPage = !!document.querySelector('x-cart');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(this.variantId, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        // Cart page needs r_cart section so x-cart can re-render items
        // Drawer needs g_cart-drawer section so the drawer re-renders
        var sectionId = isCartPage ? 'r_cart' : 'g_cart-drawer';
        return Promise.all([
          fetch('/cart.js', { cache: 'no-store' }),
          fetch('/?section_id=' + sectionId)
        ]);
      }).then(function (responses) {
        return Promise.all([responses[0].json(), responses[1].text()]);
      }).then(function (data) {
        var cart = data[0];
        var sectionHtml = data[1];
        var eventData = {
          meta: { count: cart.item_count, total_price: cart.total_price }
        };

        if (isCartPage) {
          // x-cart._onUpdate expects data.cart with these methods (mirrors cart-provider._publishUpdates)
          var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          eventData.cart = {
            getCount: function () {
              var el = doc.querySelector('[data-cart-counter]');
              return el ? el.innerText : String(cart.item_count);
            },
            getItems: function () { return doc.querySelector('[data-cart-items]'); },
            getSubtotalBlock: function () { return doc.querySelector('[data-cart-subtotal-block]'); },
            getFreeShippingBlock: function () { return doc.querySelector('[data-cart-free-shipping-block]'); }
          };
        } else {
          eventData.drawer = { section: sectionHtml, open: false };
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: { data: eventData }
        }));

        self.update(cart.total_price, cart.items || []);
        if (self.btn) { self.btn.disabled = false; self.btn.textContent = 'Claim'; }
      }).catch(function (e) {
        console.error('[FGB] add failed', e);
        if (self.btn) { self.btn.disabled = false; self.btn.textContent = 'Claim'; }
      });
    }

    listenForCartUpdates() {
      var self = this;
      document.addEventListener('cart:update', function () { self.fetchAndUpdate(); });
      document.addEventListener('cart:change', function () {
        setTimeout(function () { self.fetchAndUpdate(); }, 1500);
      });
      document.querySelectorAll('[data-dynamic="total"], [data-total]').forEach(function (node) {
        new MutationObserver(function () { self.fetchAndUpdate(); })
          .observe(node, { childList: true, subtree: true, characterData: true });
      });
    }

    fetchAndUpdate() {
      var self = this;
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        self.update(cart.total_price, cart.items || []);
        if (self.btn) { self.btn.disabled = false; self.btn.textContent = 'Claim'; }
      }).catch(function (e) { console.error('[FGB] fetch failed', e); });
    }
  }

  function initBars() {
    document.querySelectorAll('[data-free-gift-bar]:not([data-fgb-init])').forEach(function (el) {
      el.setAttribute('data-fgb-init', '');
      new FreeGiftBar(el);
    });
  }

  new MutationObserver(initBars).observe(document.documentElement, { childList: true, subtree: true });
  initBars();

})();
